import { render, staticRenderFns } from "./CompanySubset.vue?vue&type=template&id=320cfa0f&scoped=true"
import script from "./CompanySubset.vue?vue&type=script&lang=js"
export * from "./CompanySubset.vue?vue&type=script&lang=js"
import style0 from "./CompanySubset.vue?vue&type=style&index=0&id=320cfa0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320cfa0f",
  null
  
)

export default component.exports